import { Box, Tooltip } from '@mui/material'
import { type Theme } from '@mui/material/styles'

import { SoapCheckbox } from './SoapCheckbox'
import {
  SOAP_LINE_BULLET_WIDTH,
  SOAP_LINE_HEIGHT_RATIO,
  soapLineFontSize,
} from './soapSections'

interface Props {
  checked?: boolean
  onToggle?: () => void
  ariaLabel?: string
}

// 行頭チェックボックスの列. 全行で同じ幅・同じ x に置く固定スロットで、 表示/編集中/新規行の
// 3 箇所すべてで共用する (= 編集に入っても見た目が変わらない). 本文の 1 行目と同じ高さ
// (soapLineFontSize * SOAP_LINE_HEIGHT_RATIO) の箱でチェックボックスを縦中央寄せし、 本文との
// ズレを無くす (= 複数行に折り返す本文 (align-items: flex-start) と揃えるため、 行全体では
// なく 1 行目の高さだけを基準にする). `onToggle` を渡すと interactive (= 表示行のトグル),
// 渡さなければ表示専用 (編集中/新規行).
export const SoapLineBulletSlot = ({
  checked = true,
  onToggle,
  ariaLabel,
}: Props) => {
  const checkbox = (
    <Box
      sx={{
        width: SOAP_LINE_BULLET_WIDTH,
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: (theme: Theme) =>
          `calc(${soapLineFontSize(theme)} * ${SOAP_LINE_HEIGHT_RATIO})`,
      }}
    >
      <SoapCheckbox
        state={checked ? 'checked' : 'unchecked'}
        onToggle={onToggle}
        ariaLabel={ariaLabel}
      />
    </Box>
  )

  if (!onToggle) return checkbox

  return (
    <Tooltip title={ariaLabel} placement="left">
      {checkbox}
    </Tooltip>
  )
}
